export default __webpack_public_path__ + "static/fav-img04-7287c3f0611afdc94caaf371b5a857db.jpg";